import React from 'react';
import { LayoutContent, LayoutPage, FormRenderer, Form } from 'components';
import { useStoreValue } from 'store';
import { config } from '_config';
import { initFormConfig, submitHandler } from 'utils';
import { useFormInitialValues, useSteps } from '../../hooks';

const FORM_ID = 'biometricsAddressDetails';
const formConfig = initFormConfig(config.formConfigs[FORM_ID]);

export function BiometricsAddressDetails() {
  const [storeState] = useStoreValue();
  const initialValues = useFormInitialValues(FORM_ID);
  const { goNext } = useSteps();

  const onSubmit = ({ values, errors }) => {
    function updateStoreAndRedirect() {
      const newAcquisition = {
        ...storeState.acquisition,
        biometricsAddressDetails: { ...values },
      };

      goNext({ storePatch: { acquisition: newAcquisition } });
    }

    submitHandler({ submit: updateStoreAndRedirect, errors });
  };

  return (
    <LayoutPage noSessionTimeout>
      <Form
        id={FORM_ID}
        initialValues={initialValues}
        onSubmit={onSubmit}
        showSaveDraftButton
        saveDraftOnSubmit
        saveDraftOnSessionTimeout
      >
        {formData => {
          return (
            <LayoutContent>
              <FormRenderer config={formConfig} formData={formData} storeState={storeState} />
            </LayoutContent>
          );
        }}
      </Form>
    </LayoutPage>
  );
}
